import { LocationStrategy } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../../../shared/utils/re-base-data';

@Component({
    selector: 'bdo-denial',
    templateUrl: './denial.component.html',
    styleUrls: ['./denial.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DenialComponent implements OnInit {
  protected reBaseData = ReBaseData;

  constructor(
    private locationStrategy: LocationStrategy,
  ) { }

  ngOnInit(): void {
    window.sessionStorage.clear();
    this.disableBrowsersBackButton();
  }

  private disableBrowsersBackButton() {
    history.pushState(null, null, window.location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

}
